import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const PowerIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M16.66,4.71s-.04-.04-.06-.06c-.48-.45-1.22-.42-1.67.06h0c-.42.44-.43,1.12-.02,1.57,1.2,1.27,1.86,2.95,1.85,4.69-.06,3.59-2.9,6.51-6.48,6.68-1.81.07-3.58-.59-4.9-1.84-2.71-2.56-2.83-6.83-.27-9.53.41-.45.4-1.14-.01-1.58h0s-.04-.05-.07-.07c-.48-.44-1.23-.41-1.67.08-1.57,1.68-2.44,3.9-2.44,6.2,0,5.02,4.07,9.09,9.1,9.09,5.02,0,9.09-4.07,9.09-9.1,0-2.3-.87-4.52-2.44-6.2Z" />
  <path d="M10,12.81c.65,0,1.17-.53,1.17-1.17V1.17C11.17.53,10.65,0,10,0s-1.17.53-1.17,1.17v10.46c0,.65.53,1.17,1.17,1.17Z" />
 </svg>,
 "Power"
);
